<template>
  <!-- 映射表管理页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 页面标题 -->
    <!-- <div class="text_title left">映射表管理</div> -->
    <!-- 协议搜索栏 -->
    <search-box :search-list="searchList" @search="searchMappingForm" @add="addMappingForm" @del="handleDelete" @reset="resetSearch" :selectIds="selectedIds"/>
    <!-- 协议总表+分页器 -->
    <manage-table id="manageTable" :table-list="tableList" :table-data="tableData" :mapping-list="mappingTypeList" @select="handleSelect" @edit="handleEdit" @copy="handleCopy"
    :total="total" :page-size="size" :currentPage="page" @handleSelect="handleSelect" @pagechange="pageChange" @sizeChange="sizeChange"/>
    <!-- 复制操作按钮弹框 -->
    <ButtonDialog ref="buttonDialog" :dialogFormVisible="dialogFormVisible" :dialogTitle="dialogTitle" :dialogWidth="dialogWidth" @update:modelValue="dialogFormVisible = $event" @confirm="submitForm('ruleForm')">
    <slot>
      <el-form label-position="right" label-width="100px" :model="formLabelAlign" :rules="rules" ref="ruleForm">
        <el-form-item label="映射表名称" prop="mappingName">
          <el-input v-model="formLabelAlign.mappingName" placeholder="请输入映射表名称" clearable></el-input>
        </el-form-item>
      </el-form>
    </slot>
    </ButtonDialog>
  </div>
</template>

<script>
import SearchBox from '@/components/table/SearchBox.vue'
import ManageTable from '@/components/table/ManageTable.vue'

import { mappingTableManageList } from '@/data/tableList'
import { mappingTypeList } from '@/data/typeList'
import { Message } from 'element-ui'
import { getMappingform, deleteMappingform, viewValueMappingform, viewBitMappingform, createValueMappingform, createBitMappingform } from '@/api/mappingform/mappingform'
import { removeIds } from '@/utils/common'
import ButtonDialog from '@/components/dialog/ButtonDialog.vue'

export default {
  name: 'FormManageView',
  components: {
    SearchBox,
    ManageTable,
    ButtonDialog
  },
  data () {
    return {
      // 映射表类型映射
      mappingTypeList: mappingTypeList,
      // 映射表管理表头
      tableList: mappingTableManageList,
      // 搜索栏列表
      searchList: mappingTableManageList,
      // 映射表数据
      tableData: [],
      // 选中的映射表id
      selectedIds: [],
      // 当前页面
      page: 1,
      // 每页显示条数
      size: 10,
      // 总条数
      total: 0,
      // 字典弹窗是否显示
      dialogFormVisible: false,
      // 字典弹窗标题
      dialogTitle: '',
      // 字典弹窗宽度
      dialogWidth: '30%',
      formLabelAlign: {
        mappingName: ''
      },
      rules: {
        mappingName: [
          { required: true, message: '请输入映射表名称', trigger: 'blur' }
        ]
      },
      copyRow: {},
      loading: false
    }
  },
  mounted () {
    this.getMappingForms()
    this.$assignDictOptions(this.searchList, { mappingType: 'mapping_type' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },

  watch: {
    $route: {
      handler (to, from) {
        this.getMappingForms()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取映射表列表
    async fetchMappingForms (params = {}) {
      this.loading = true
      try {
        const res = await getMappingform({
          page: this.page,
          size: this.size,
          ...params
        })
        if (res.code === 200) {
          this.tableData = res.data.records.map(row => ({
            ...row,
            protocolName: row.protocolName ? row.protocolName : '/',
            mappingType: this.$getDictLabel(this.selectDictionary, 'mapping_type', row.mappingType)
          }))
          this.total = res.data.total
        } else {
          Message.error(res.message || '获取协议列表失败')
        }
      } catch (error) {
        Message.error('网络错误，请重试')
        console.error('获取协议列表出错:', error)
      } finally {
        this.loading = false
      }
    },
    // 初始化加载
    getMappingForms () {
      this.fetchMappingForms()
    },
    // 搜索协议
    searchMappingForm (params) {
      // 保存搜索参数
      this.page = 1 // 重置页码
      this.fetchMappingForms(params)
    },
    resetSearch () {
      this.page = 1
      this.fetchMappingForms()
    },
    // 选中映射表
    handleSelect (selection) {
      this.selectedIds = selection.map(item => item.id)
    },
    // 编辑
    handleEdit (row) {
      this.$editHandler('/form/create', '编辑映射表', 'FormCreateView', 'edit', row.id, row.mappingType)
    },
    handleCopy (row) {
      this.formLabelAlign.mappingName = ''
      this.dialogTitle = '复制'
      this.dialogFormVisible = true
      this.copyRow = row
    },
    copyData (row) {
      // 创建API函数映射
      const apiMap = {
        值映射: {
          view: viewValueMappingform,
          create: createValueMappingform
        },
        bit位映射: {
          view: viewBitMappingform,
          create: createBitMappingform
        }
      }
      // 获取当前映射表类型对应的API
      const apis = apiMap[row.mappingType]
      if (!apis) {
        Message.error(`不支持的映射表类型: ${row.mappingType}`)
        return
      }
      this.$confirm('是否确定要复制该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        this.dialogFormVisible = false
        try {
          const res = await apis.view(row.id)
          if (res.code === 200) {
            const mappingData = { ...res.data }
            const mappingValueNoId = removeIds(mappingData)
            const params = {
              ...mappingValueNoId,
              mappingName: this.formLabelAlign.mappingName
            }
            const res1 = await apis.create(params)
            if (res1.code === 200) {
              Message.success(res1.msg)
              this.fetchMappingForms()
              this.loading = false
            }
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
        
      }).catch(() => { return false })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.copyData(this.copyRow)
        } else {
          console.error('表单验证失败')
          return false
        }
      })
    },
    // 新增映射表
    addMappingForm () {
      this.$addHandler('/form/create', '创建映射表', 'add')
    },

    // 删除映射表
    async handleDelete () {
      const success = await this.$deleteHandler(deleteMappingform, this.selectedIds.toString(), '映射表')
      if (success) {
        this.selectedIds = []
        this.fetchMappingForms()
      }
    },
    // 分页器点击
    pageChange (val) {
      this.page = val
      this.fetchMappingForms()
    },
    // 页码大小改变
    sizeChange (val) {
      this.size = val
      this.page = 1 // 重置页码
      this.fetchMappingForms()
    }
  }
}
</script>

<style>
</style>
